<template>
  <div id="incoming-events">

    <div class="incoming-events-container">
      <EventBlock :data="incomingevents" />  
    </div>

    <infinite-loading :infinite-scroll-listen-for-event="true" @infinite="getComingEvents" spinner="waveDots">
      <div slot="no-more"></div>
      <NoData slot="no-results"
        :title="$t('nodatakeys.homeupcomingevents.nodatatitle')"
        :description="$t('nodatakeys.homeupcomingevents.nodatadesc')"
        anim="holacon-calender-lottie-v2-without-background"
        :loading="loading"
        :button="$t('nodatakeys.homeupcomingevents.nodatabutton')"
        @btnClick="getComingEvents"
      />
    </infinite-loading>

    <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="response.hasError" md-persistent>
      <i class="fa fa-exclamation-triangle"></i><span>{{ response.message }}</span>
    </md-snackbar>
    
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import InfiniteLoading from "vue-infinite-loading";
import NoData from "@/modules/NoData";
import EventBlock from "@/modules/EventBlock";

export default {
  name: "IncomingEvents",
  components: {
    EventBlock,
    InfiniteLoading,
    NoData
  },
  data() {
    return {
      incomingevents: [],
      searchTerm: null,
      loading: false,
      moment, 
      response: {
        message: null,
        validationErrors: [],
        hasError: false
      },
    };
  },

  methods: {

    async getComingEvents($state, reset) {
      var res = await axios.post("/Explore/SearchEvent", { skip: reset ? 0 : this.incomingevents.length, take: 10, searchType: 1, searchTerm: this.searchTerm});
      if(res.data.hasError)
      {
        this.snackbar = { show: true, message: res.data.message };
      } 
      else
      {
        if (reset) {
          this.incomingevents = res.data.data.items;
        } else {
          this.incomingevents = [
            ...this.incomingevents,
            ...res.data.data.items
          ];
        }
      } 
      try {
        if (res.data.data.items.length == 0) $state.complete();
        else $state.loaded();
      } catch (err) {}
      this.loading = false;
    },

  }
};
</script>

<style lang="less">
#incoming-events {
  background-color: transparent;
  margin-top: 30px;

  .incoming-events-container {
    display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 16px;
      margin: 0px;
  }

}

@media (max-width: 768px) {
  #incoming-events {
    .incoming-events-container {
      grid-template-columns: 1fr !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IncomingEvents.vue